/* Fast Fridgespares - "Will it fit your fridge?" compatibility data.
 *
 * HOW TO EDIT
 *  models   = models verified as compatible with the part (popup says "exact match")
 *  reported = models listed by other suppliers but not verified by us (popup says "likely fit, we will confirm")
 *             -> once verified, move a model from `reported` to `models`
 *  parts    = part numbers a customer may type from their old part
 *  brands   = brand ids (see `brands` below) the part is listed for at brand level
 *  kind     = exact (model list), sized (match size/wattage), universal (match specs), generic (not model specific)
 *  compare  = what the customer must still match on their old part
 */
window.FFS_FIT_DATA = {
  contact: {
    phone: '0405 972 558',
    phoneHref: '0405972558',
    email: 'sales@fastfridgespares.com.au',
    findUrl: '/pages/find-your-part',
    modelGuide: '/blogs/guides/how-to-find-fridge-model-number'
  },

  brands: {
    westinghouse: { label: 'Westinghouse', alias: ['westinghouse'] },
    kelvinator: { label: 'Kelvinator', alias: ['kelvinator', 'kalvinator'] },
    fisherpaykel: { label: 'Fisher & Paykel', alias: ['fisher', 'paykel', 'f&p', 'fnp'] },
    simpson: { label: 'Simpson', alias: ['simpson'] },
    electrolux: { label: 'Electrolux', alias: ['electrolux'] },
    sharp: { label: 'Sharp', alias: ['sharp'] },
    maytag: { label: 'Maytag', alias: ['maytag'] },
    whirlpool: { label: 'Whirlpool', alias: ['whirlpool'] },
    amana: { label: 'Amana', alias: ['amana'] },
    bromic: { label: 'Bromic', alias: ['bromic'] },
    skope: { label: 'Skope', alias: ['skope'] },
    skipio: { label: 'Skipio', alias: ['skipio'] },
    carel: { label: 'Carel', alias: ['carel'] },
    dixell: { label: 'Dixell', alias: ['dixell'] },
    evco: { label: 'Evco', alias: ['evco'] },
    elitech: { label: 'Elitech', alias: ['elitech'] }
  },

  products: {
    /* ---------- Defrost heaters ---------- */
    'westinghouse-kelvinator-rf116-refrigerator-dual-pass-350w-440mm-defrost-elemen': {
      kind: 'exact',
      name: 'RF116 defrost heater (350W, 440mm)',
      models: ['RJ362V', 'RJ392V', 'RJ422V', 'RJ442V', 'RJ446V', 'NB380C', 'NB400C', 'NB400H'],
      reported: ['RJ393V'],
      parts: ['RF116', '1441000', 'KH11435'],
      brands: ['westinghouse', 'kelvinator'],
      compare: [['Power', '350W'], ['Length', '440mm'], ['Style', 'Dual pass (double pass)']]
    },
    'westinghouse-and-kalvinator-fridge-defrost-heater-450w-520mm-rf153': {
      kind: 'sized',
      name: 'RF153 defrost heater (450W, 520mm)',
      models: [],
      reported: ['RJ422S', 'RJ422BS', 'RJ412Q', 'RJ442Q', 'RJ452S', 'RJ452T', 'RJ453T', 'RJ456T', 'RJ424T', 'BJ423T', 'BJ424S', 'BJ424BS', 'BJ424T', 'BJ425S', 'BJ425BS', 'BJ425T', 'BJ426T', 'FJ383T'],
      parts: ['RF153', '1439802'],
      brands: ['westinghouse', 'kelvinator'],
      blurb: 'Westinghouse uses small, medium and large defrost heaters. This is the medium 450W, 520mm size, so it only suits if your old element matches.',
      compare: [['Power', '450W'], ['Length', '520mm'], ['Style', 'Medium double pass']]
    },
    'westinghouse-side-by-side-fridge-defrost-heater': {
      kind: 'exact',
      name: 'SE114 side by side defrost heater (450W)',
      models: ['RS643V', 'RS662V', 'RS645V', 'RS663V'],
      reported: ['ESM6600SA', 'ESM6600WA', 'ESM6470SA', 'ESM6470WA', 'ESM6477SA'],
      parts: ['SE114', '1445347', '1434210', '1408197'],
      brands: ['westinghouse'],
      compare: [['Power', '450W'], ['Shape', 'Side by side element (SE114)']]
    },
    'fisher-paykel-defrost-heater-element-322w-46cm': {
      kind: 'exact',
      name: 'Fisher & Paykel defrost heater (322W, 46cm)',
      models: ['E442B', 'E441T', 'E440T', 'E413T', 'E406B', 'E361T'],
      reported: ['N150', 'N210'],
      parts: ['FR-06V2', 'RF202'],
      brands: ['fisherpaykel'],
      compare: [['Power', '322W'], ['Length', '46cm (460mm)'], ['Refrigerant', 'R134a models only, not R600a']]
    },
    'defrost-heater-element-355w-57cm-240v-fisher-paykel-fridge': {
      kind: 'sized',
      name: 'Fisher & Paykel defrost heater (355W, 57cm)',
      models: [],
      reported: [],
      parts: ['FR-07V2', 'RF203'],
      brands: ['fisherpaykel'],
      blurb: 'Fisher & Paykel uses several element lengths. This is the longer 355W, 57cm size, so it only suits if your old element matches.',
      compare: [['Power', '355W'], ['Length', '57cm']]
    },

    /* ---------- Timers and thermostat ---------- */
    'genuine-westinghouse-fridge-defrost-timer-rj390p-rj390m-rj280m-sr300a-r-n476c': {
      kind: 'exact',
      name: 'Westinghouse defrost timer (TMDE 520 ZC1)',
      models: ['RJ390P', 'RJ390M', 'RJ280M', 'SR300A-R', 'N476C'],
      reported: [],
      parts: ['TMDE 520 ZC1'],
      brands: ['westinghouse'],
      compare: [['Part marking', 'TMDE 520 ZC1'], ['Rating', 'AC 200-240V, 10A'], ['Type', 'Mechanical timer, not an electronic control board']]
    },
    'timer-defrost-6hr-21min': {
      kind: 'universal',
      name: 'Defrost timer 6hr 21min',
      models: [],
      reported: ['BJ504T', 'BJ504Q', 'BJ504BQ', 'BJ504M', 'BJ505M', 'BJ414M', 'BJ415M', 'BJ424T', 'FJ383T', 'FJ383K', 'FJ383G', 'FJ303K', 'FJ303G', 'FJ351E', 'FN291V', 'FN291C', 'WSE6070SF', 'WSE6100SF'],
      parts: [],
      brands: [],
      blurb: 'A generic mechanical defrost timer marked 6hr 21min. It is a universal part, so the markings, terminals and mounting on your old timer decide the fit.',
      compare: [['Marking', '6hr 21min'], ['Terminals', 'Same layout as your old timer'], ['Mounting', 'Same fixing as your old timer'], ['Type', 'Mechanical timer, not an electronic control board']]
    },
    'defrost-thermostat-defrost-termination-klixon-type-240v-sl5708-l50-25f-rf027m': {
      kind: 'universal',
      name: 'Klixon defrost thermostat (SL5708)',
      models: [],
      reported: [],
      parts: ['SL5708', 'L50-25F', 'RF027M'],
      brands: ['simpson', 'electrolux', 'westinghouse', 'kelvinator', 'maytag', 'whirlpool', 'amana'],
      blurb: 'A universal Klixon-type defrost thermostat, listed for upright freezers, mini freezers, mini fridges and portable fridges.',
      compare: [['Part number', 'SL5708, L50-25F or RF027M'], ['Type', 'Klixon type, 240V'], ['Mounting', 'Clips onto the evaporator coil like your old one']]
    },

    /* ---------- Fan motors ---------- */
    'commercial-refrigeration-condenser-fan-motor-10w-1300-1550rpm-cl-h': {
      kind: 'universal',
      name: 'Condenser fan motor 10W (YZ10-20)',
      models: [], reported: [], parts: ['YZ10-20'],
      brands: ['bromic', 'skope', 'skipio'],
      blurb: 'A universal motor listed for chest and upright freezers, undercounter fridges and freezers, compact fridges, kegerators and coolrooms.',
      compare: [['Power', '10W, 240V'], ['Speed', '1300/1550 RPM'], ['Size and mounting', 'Same as your old motor']]
    },
    'commercial-refrigeration-condenser-fan-motor-25w-1300-1550rpm-cl-h': {
      kind: 'universal',
      name: 'Condenser fan motor 25W (YZ25-40)',
      models: [], reported: [], parts: ['YZ25-40'],
      brands: ['bromic', 'skope'],
      blurb: 'A universal motor for larger commercial fridges, freezers and coolrooms.',
      compare: [['Power', '25W, 240V'], ['Speed', '1300/1550 RPM'], ['Size and mounting', 'Same as your old motor']]
    },
    'products-commercial-refrigeration-condenser-fan-motor-5w-240v-1300-1550rpm-class-h': {
      kind: 'universal',
      name: 'Condenser fan motor 5W (YZ5-13)',
      models: [], reported: [], parts: ['YZ5-13'],
      brands: ['bromic', 'skope', 'skipio'],
      blurb: 'A universal motor for smaller commercial fridges, freezers and coolrooms.',
      compare: [['Power', '5W, 240V'], ['Speed', '1300/1550 RPM'], ['Size and mounting', 'Same as your old motor']]
    },
    'axial-fan-g12038ha2sl-240v-21w-120mm': {
      kind: 'universal',
      name: 'Axial fan G12038HA2SL (120mm, 21W)',
      models: [], reported: [], parts: ['G12038HA2SL'],
      brands: ['bromic', 'skope', 'skipio'],
      blurb: 'A complete 120mm fan for evaporator or condenser airflow in chest freezers, display fridges and underbench fridge freezers.',
      compare: [['Size', '120 x 120 x 38mm'], ['Power', '21W, AC 200-240V'], ['Mounting', 'Hole spacing like your old fan']]
    },
    'universal-fridge-evaporator-fan-motor-5w-240v-yjf61-10': {
      kind: 'universal',
      name: 'Evaporator fan motor 5W (YJF61/10)',
      models: [],
      reported: ['RJ212S', 'RJ412Q', 'RJ452S', 'RJ532S', 'RP432V', 'FJ302V', 'FJ362V', 'BJ415G', 'BJ424T', 'WBM3700PB', 'WBM3700SB', 'WBM3700WB', 'WBM4000SB', 'WBM4000WB', 'WBM4300SB', 'WBM4300WB', 'WBM5100PA', 'WBM5100PB', 'WBM5100WB'],
      parts: ['YJF61/10', '1434362'],
      brands: ['westinghouse', 'simpson', 'sharp', 'electrolux', 'kelvinator', 'maytag', 'bromic', 'skope', 'skipio'],
      blurb: 'A universal evaporator fan motor with blade, listed for house fridges including Westinghouse, Simpson, Sharp, Electrolux, Kelvinator and Maytag.',
      compare: [['Power', '5W, AC 220/240V'], ['Speed', '2600 r/min'], ['Rotation', 'CCW, reversible'], ['Mounting and blade', 'Same as your old motor']]
    },

    /* ---------- Controllers and electrical ---------- */
    'digital-temperature-controller-ek-3030-elitech-coolroom': {
      kind: 'universal',
      name: 'Elitech EK-3030 controller',
      models: [], reported: [], parts: ['EK-3030', 'XR60'],
      brands: ['carel', 'dixell', 'evco', 'elitech', 'bromic', 'skope', 'skipio'],
      blurb: 'A low and medium temperature controller for coolrooms, freezer rooms and commercial fridges, listed for installations that use Carel, Dixell and Evco controllers.',
      compare: [['Cut-out', '71mm x 29mm'], ['Load', 'Up to 10A or 16A (220VAC), as listed'], ['Probe and wiring', 'Suit your installation']]
    },
    'controller-mounting-box-dixell-carel-elitech-pre-cut-coolroom': {
      kind: 'universal',
      name: 'Controller mounting box',
      models: [], reported: [], parts: [],
      brands: ['dixell', 'carel', 'elitech'],
      blurb: 'A pre-cut plastic body for Dixell, Carel and Elitech coolroom controllers. Not every model has the same cut-out.',
      compare: [['Controller cut-out', 'Same opening as the box']]
    },
    'backup-relay-30a-3hp-240v-coil-suits-digital-defrost-controls': {
      kind: 'universal',
      name: 'Backup relay 30A (240V coil)',
      models: [], reported: [], parts: ['HF-116F-2/240-L1HS', 'JQX-116F-2/240-A-L1H-S'],
      brands: ['skipio'],
      blurb: 'A 30A backup relay that takes the heavy switching off a digital defrost controller on larger single-phase plants.',
      compare: [['Coil voltage', '240V'], ['Load', 'Up to 30A'], ['Terminals', '6.3mm male spades'], ['Part number', 'HF-116F-2/240-L1HS']]
    },
    '1x-refrigeration-fridge-bullet-piercing-valve-for-copper-pipe-1-4-5-16-3-8': {
      kind: 'universal',
      name: 'Bullet piercing valve (1/4", 5/16", 3/8")',
      models: [], reported: [], parts: [],
      brands: [],
      blurb: 'A service access valve that suits 1/4", 5/16" and 3/8" outside diameter copper tube. Refrigerant work needs an ARC licence.',
      compare: [['Pipe size', '1/4", 5/16" or 3/8" OD copper'], ['Clearance', 'About 2" of clean, straight tube']]
    },

    /* ---------- Not fridge specific ---------- */
    'cable-ties-black-nylon-66-4-8x250mm-pack-of-500': { kind: 'generic', name: 'Cable ties' },
    'single-screw-bp-connector-6mm-32amp-jar-of-100': { kind: 'generic', name: 'BP connectors' }
  }
};
